import { createContext,useContext, useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode"; 
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem("token"));
  const [user, setUser] = useState(() => {
    const savedToken = localStorage.getItem("token");
    if (savedToken) {
      try {
        return jwtDecode(savedToken);
      } catch (e) {
        localStorage.removeItem("token");
        return null;
      }
    }
    return null;
  });

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        if (!user || JSON.stringify(user) !== JSON.stringify(decoded)) {
          setUser(decoded);
        }
      } catch (e) {
        console.error("Token decode error:", e);
        setUser(null);
      }
    } else {
      if (user !== null) {
        setUser(null);
      }
    }
  }, [token, user]);

  return (
    <AuthContext.Provider value={{ user, token, setUser, setToken }}>
      {children}
      
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
